import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import I18n from "redux-i18n"

import store, { history } from './store'
import translations from './translations'
import App from './containers/App'

import registerServiceWorker from './registerServiceWorker'

import './index.css'

const target = document.getElementById('root')

render(
  <Provider store={store}>
    <I18n translations={translations} initialLang="en" fallbackLang="cn">
      <ConnectedRouter history={history} >
        <App />
      </ConnectedRouter>
    </I18n>
  </Provider>,
  target
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js